<template>
    <div>
        <div v-if="verifiedMessage">
            <b-alert show dismissible fade variant="success" class="welcome_message">
                <p class="my-0">Great! Your email is now verified.</p>
            </b-alert>
        </div>

        <div v-if="askToResendVerification">
            <b-alert show dismissible fade variant="warning" class="welcome_message">
                <p class="my-0">Please confirm your email. <a href="#" @click="resendVerification">Resend the verification</a>.</p>
            </b-alert>
        </div>

        <div v-if="$auth.user().has_inactive_channels">
            <b-alert show dismissible fade variant="danger" class="welcome_message">
                <p class="my-0">Some channels are not active. Please reconnect or delete the channels with errors. <router-link to="/channels">Go to channels</router-link>.</p>
            </b-alert>
        </div>

        <div v-if="$auth.user().has_no_knowledge">
            <b-alert show dismissible fade variant="danger" class="welcome_message">
                <p class="my-0">Some channels do not have knowledge learned from your website. <router-link to="/channels">Start teaching them</router-link>.</p>
            </b-alert>
        </div>

        <div v-if="$auth.user().has_no_name_or_description">
            <b-alert show dismissible fade variant="danger" class="welcome_message">
                <p class="my-0">Some channels do not have a from name or business description. <router-link to="/channels">Provide missing info</router-link>.</p>
            </b-alert>
        </div>
    </div>
</template>

<script>
import NotificationPop from "../mixins/NotificationPop";

export default {
    mixins: [NotificationPop],
    data: () => ({
        loading: true,
        welcomeMessage: false,
        verifiedMessage: false,
        askToResendVerification: false,
        unsubscribedEmailReportsMessage: false,
    }),
    async created() {
        if('verified' in this.$route.query) {
            this.verifiedMessage = true
        }
        if('unsubscribed_email_reports' in this.$route.query) {
            this.unsubscribedEmailReportsMessage = true
        }

        // Load user to see if this one has verified the email
        this.$http.get('/user/' + this.$auth.user().id)
            .then(({data}) => {
                if(data.data.email_verified_at === null) {
                    this.askToResendVerification = true
                }
            })
            .catch(error => {
                this.loadingUser = true
                console.log(error.response)
                this.popNotification('Could not load your user', 'danger')
            })

    },
    methods: {
        /**
         * Resend verification for emails
         */
        resendVerification: function () {
            this.$http.post('/user/resend_verification')
                .then(() => {
                    this.askToResendVerification = false
                    this.popNotification('Verification email sent. Please also check your SPAM box.', 'success')
                })
                .catch(error => {
                    // handle authentication and validation errors here
                    console.log(error)
                    if(error.response.status === 429) {
                        this.askToResendVerification = false
                        this.popNotification('Could not request new verification email. You have tried too many times. Please wait one minute or contact support.', 'danger')
                    } else {
                        this.popNotification('Could not request new verification email. Please contact support.', 'danger')
                    }
                })
        },
    }
}
</script>
